import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useTranslate } from '@/translations';
import { ButtonsWrapper, PageCount, Wrapper } from './PdfReader.styled';
import { Button, Spin } from 'antd';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface PdfReaderProps {
  src: string;
}

export const PDFReader = ({ src }: PdfReaderProps) => {
  const { t } = useTranslate();

  const [pageCount, setPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  const onLoadSuccess = ({ numPages }: { numPages: number }) =>
    setPageCount(numPages);

  const prevPage = () => setPageNumber((prevPageNumber) => prevPageNumber - 1);

  const nextPage = () => setPageNumber((prevPageNumber) => prevPageNumber + 1);

  return (
    <Wrapper>
      <Document
        file={src}
        onLoadSuccess={onLoadSuccess}
        loading={<Spin spinning />}
      >
        <Page
          pageNumber={pageNumber}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
      {!!pageCount && (
        <ButtonsWrapper>
          <Button onClick={prevPage} disabled={pageNumber <= 1}>
            {t('prev')}
          </Button>
          <PageCount>
            {pageNumber} / {pageCount}
          </PageCount>
          <Button onClick={nextPage} disabled={pageNumber >= pageCount}>
            {t('next')}
          </Button>
        </ButtonsWrapper>
      )}
    </Wrapper>
  );
};
